import React from 'react';
import StepSelector from './StepSelector';

type IndexBasedStepSelectorProps<T> = {
  items: T[];
  selectedIndex: number;
  setSelectedIndex: (index: number) => void;
  getItemLabel: (item: T) => string;
  theme?: 'benefits' | 'howItWorks';
  className?: string;
};

/**
 * Wrapper component for StepSelector that provides an index-based interface.
 * This allows components to work with indices while still using the existing
 * StepSelector component that expects object-based selection.
 */
const IndexBasedStepSelector = <T,>({
  className = '',
  getItemLabel,
  items,
  selectedIndex,
  setSelectedIndex,
  theme = 'benefits',
}: IndexBasedStepSelectorProps<T>) => {
  const selectedItem = items[selectedIndex];

  const handleItemSelect = (item: T) => {
    const index = items.findIndex(i => i === item);
    if (index !== -1) {
      setSelectedIndex(index);
    }
  };

  return (
    <StepSelector
      items={items}
      selectedItem={selectedItem}
      onItemSelect={handleItemSelect}
      getItemLabel={getItemLabel}
      theme={theme}
      className={className}
    />
  );
};

export default IndexBasedStepSelector;
